import { findCalculationModuleById, isCalculationModuleAvailable, usesCombinedSetup } from '@/config/calculationModules';
import {
  ADAPTIVE_RT_MIN_STAGE_SLOTS,
  createEmptyStage,
  useAdaptiveRtStore,
} from '@/stores/adaptiveRtStore';
import { tryRestoreAdaptiveRtCourseWorkspace } from '@/utils/tryRestoreAdaptiveRtCourseWorkspace';

/**
 * Страница курса внутри уже выбранного модуля.
 * @param {string|null|undefined} moduleId
 */
export function courseSelectionLocation(moduleId) {
  if (!moduleId) return { path: '/app/calculate' };
  return { path: '/app/calculate/course', query: { mode: moduleId } };
}

/**
 * Экран расчёта TCP/NTCP (куда ведёт «Перейти к расчёту»).
 * @param {string|null|undefined} path
 */
export function isCalculationScreenPath(path) {
  return typeof path === 'string' && path.startsWith('/app/structure-model-selection');
}

/**
 * Шаг после выбора курса: параметры, загрузка ГДО или этапы Adaptive RT.
 * @param {string|null|undefined} moduleId
 */
export function moduleCalculationLocation(moduleId) {
  const calcModule = findCalculationModuleById(moduleId);
  if (!calcModule || !isCalculationModuleAvailable(calcModule)) return { path: '/app/calculate' };
  if (calcModule.uploadType === 'multi_dvh_stages') {
    return {
      path: '/app/calculate/adaptive-rt/upload',
      query: { mode: calcModule.id },
    };
  }
  const path = usesCombinedSetup(calcModule.id)
    ? '/app/calculate/upload'
    : '/app/calculate/params';
  return { path, query: { mode: calcModule.id } };
}

/**
 * Восстанавливает этапы Adaptive RT и оставляет минимум пустых слотов.
 * @param {string|number|null|undefined} courseId
 */
export async function ensureAdaptiveRtStageSlots(courseId) {
  if (courseId != null) {
    await tryRestoreAdaptiveRtCourseWorkspace(courseId, {
      skipIfStagesHavePlans: true,
    });
  }
  const adaptiveStore = useAdaptiveRtStore();
  if (adaptiveStore.stages.length === 0) {
    adaptiveStore.setStages(
      Array.from({ length: ADAPTIVE_RT_MIN_STAGE_SLOTS }, () => createEmptyStage())
    );
  }
}
